/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthPrep_guidesRouteImport } from './routes/_auth/prep_guides'
import { Route as LoginCallbackRouteImport } from './routes/login.callback'
import { Route as AuthAppointmentsIndexRouteImport } from './routes/_auth/appointments/index'
import { Route as AuthCarePlanPatientIdRouteImport } from './routes/_auth/care-plan/$patientId'
import { Route as AuthFaxesIndexRouteImport } from './routes/_auth/faxes/index'
import { Route as AuthHomeIndexRouteImport } from './routes/_auth/home/index'
import { Route as AuthInboxIndexRouteImport } from './routes/_auth/inbox/index'
import { Route as AuthOrganizationsIndexRouteImport } from './routes/_auth/organizations/index'
import { Route as AuthOrganizationsOrganizationIdRouteImport } from './routes/_auth/organizations/$organizationId'
import { Route as AuthPatientsIndexRouteImport } from './routes/_auth/patients/index'
import { Route as AuthPatientsPatientIdRouteImport } from './routes/_auth/patients/$patientId'
import { Route as AuthPractitionersIndexRouteImport } from './routes/_auth/practitioners/index'
import { Route as AuthPractitionersPractitionerIdRouteImport } from './routes/_auth/practitioners/$practitionerId'
import { Route as AuthPractitionersNewRouteImport } from './routes/_auth/practitioners/new'
import { Route as AuthScheduleAvailabilityIndexRouteImport } from './routes/_auth/schedule-availability/index'
import { Route as AuthSupportIndexRouteImport } from './routes/_auth/support/index'
import { Route as AuthWorklistIndexRouteImport } from './routes/_auth/worklist/index'
import { Route as AuthCarePlanPatientIdIndexRouteImport } from './routes/_auth/care-plan/$patientId/index'
import { Route as AuthCarePlanPatientIdDataRouteImport } from './routes/_auth/care-plan/$patientId/data'
import { Route as AuthCarePlanPatientIdDayRouteImport } from './routes/_auth/care-plan/$patientId/day'
import { Route as AuthCarePlanPatientIdErx2RouteImport } from './routes/_auth/care-plan/$patientId/erx2'
import { Route as AuthCarePlanPatientIdPlanRouteImport } from './routes/_auth/care-plan/$patientId/plan'
import { Route as AuthInternalAgentTraceIndexRouteImport } from './routes/_auth/internal/agent-trace/index'
import { Route as AuthInternalAgentTraceHealthRouteImport } from './routes/_auth/internal/agent-trace/health'
import { Route as AuthInternalProtocolsIndexRouteImport } from './routes/_auth/internal/protocols/index'
import { Route as AuthInternalProtocolsCanonicalRouteImport } from './routes/_auth/internal/protocols/$canonical'
import { Route as AuthOrganizationsOrganizationIdIndexRouteImport } from './routes/_auth/organizations/$organizationId/index'
import { Route as AuthOrganizationsOrganizationIdExternalProvidersRouteImport } from './routes/_auth/organizations/$organizationId/external-providers'
import { Route as AuthPatientsPatientIdIndexRouteImport } from './routes/_auth/patients/$patientId/index'
import { Route as AuthPractitionersPractitionerIdIndexRouteImport } from './routes/_auth/practitioners/$practitionerId/index'
import { Route as AuthProviderPatientIdIndexRouteImport } from './routes/_auth/provider/$patientId/index'
import { Route as AuthInternalAgentTraceTriggerTypeTriggerIdRouteImport } from './routes/_auth/internal/agent-trace/$triggerType/$triggerId'
import { Route as AuthPractitionersPractitionerIdProjectMembershipMembershipIdRouteImport } from './routes/_auth/practitioners/$practitionerId/project-membership.$membershipId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPrep_guidesRoute = AuthPrep_guidesRouteImport.update({
  id: '/prep_guides',
  path: '/prep_guides',
  getParentRoute: () => AuthRoute,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAppointmentsIndexRoute = AuthAppointmentsIndexRouteImport.update({
  id: '/appointments/',
  path: '/appointments/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCarePlanPatientIdRoute = AuthCarePlanPatientIdRouteImport.update({
  id: '/care-plan/$patientId',
  path: '/care-plan/$patientId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFaxesIndexRoute = AuthFaxesIndexRouteImport.update({
  id: '/faxes/',
  path: '/faxes/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeIndexRoute = AuthHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxIndexRoute = AuthInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsIndexRoute = AuthOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsOrganizationIdRoute =
  AuthOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPatientsIndexRoute = AuthPatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPatientsPatientIdRoute = AuthPatientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPractitionersIndexRoute = AuthPractitionersIndexRouteImport.update({
  id: '/practitioners/',
  path: '/practitioners/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPractitionersPractitionerIdRoute =
  AuthPractitionersPractitionerIdRouteImport.update({
    id: '/practitioners/$practitionerId',
    path: '/practitioners/$practitionerId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPractitionersNewRoute = AuthPractitionersNewRouteImport.update({
  id: '/practitioners/new',
  path: '/practitioners/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScheduleAvailabilityIndexRoute =
  AuthScheduleAvailabilityIndexRouteImport.update({
    id: '/schedule-availability/',
    path: '/schedule-availability/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSupportIndexRoute = AuthSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorklistIndexRoute = AuthWorklistIndexRouteImport.update({
  id: '/worklist/',
  path: '/worklist/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCarePlanPatientIdIndexRoute =
  AuthCarePlanPatientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCarePlanPatientIdRoute,
  } as any)
const AuthCarePlanPatientIdDataRoute =
  AuthCarePlanPatientIdDataRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => AuthCarePlanPatientIdRoute,
  } as any)
const AuthCarePlanPatientIdDayRoute =
  AuthCarePlanPatientIdDayRouteImport.update({
    id: '/day',
    path: '/day',
    getParentRoute: () => AuthCarePlanPatientIdRoute,
  } as any)
const AuthCarePlanPatientIdErx2Route =
  AuthCarePlanPatientIdErx2RouteImport.update({
    id: '/erx2',
    path: '/erx2',
    getParentRoute: () => AuthCarePlanPatientIdRoute,
  } as any)
const AuthCarePlanPatientIdPlanRoute =
  AuthCarePlanPatientIdPlanRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => AuthCarePlanPatientIdRoute,
  } as any)
const AuthInternalAgentTraceIndexRoute =
  AuthInternalAgentTraceIndexRouteImport.update({
    id: '/internal/agent-trace/',
    path: '/internal/agent-trace/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInternalAgentTraceHealthRoute =
  AuthInternalAgentTraceHealthRouteImport.update({
    id: '/internal/agent-trace/health',
    path: '/internal/agent-trace/health',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInternalProtocolsIndexRoute =
  AuthInternalProtocolsIndexRouteImport.update({
    id: '/internal/protocols/',
    path: '/internal/protocols/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInternalProtocolsCanonicalRoute =
  AuthInternalProtocolsCanonicalRouteImport.update({
    id: '/internal/protocols/$canonical',
    path: '/internal/protocols/$canonical',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOrganizationsOrganizationIdIndexRoute =
  AuthOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrganizationsOrganizationIdRoute,
  } as any)
const AuthOrganizationsOrganizationIdExternalProvidersRoute =
  AuthOrganizationsOrganizationIdExternalProvidersRouteImport.update({
    id: '/external-providers',
    path: '/external-providers',
    getParentRoute: () => AuthOrganizationsOrganizationIdRoute,
  } as any)
const AuthPatientsPatientIdIndexRoute =
  AuthPatientsPatientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPatientsPatientIdRoute,
  } as any)
const AuthPractitionersPractitionerIdIndexRoute =
  AuthPractitionersPractitionerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPractitionersPractitionerIdRoute,
  } as any)
const AuthProviderPatientIdIndexRoute =
  AuthProviderPatientIdIndexRouteImport.update({
    id: '/provider/$patientId/',
    path: '/provider/$patientId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInternalAgentTraceTriggerTypeTriggerIdRoute =
  AuthInternalAgentTraceTriggerTypeTriggerIdRouteImport.update({
    id: '/internal/agent-trace/$triggerType/$triggerId',
    path: '/internal/agent-trace/$triggerType/$triggerId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute =
  AuthPractitionersPractitionerIdProjectMembershipMembershipIdRouteImport.update(
    {
      id: '/project-membership/$membershipId',
      path: '/project-membership/$membershipId',
      getParentRoute: () => AuthPractitionersPractitionerIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/prep_guides': typeof AuthPrep_guidesRoute
  '/login/callback': typeof LoginCallbackRoute
  '/care-plan/$patientId': typeof AuthCarePlanPatientIdRouteWithChildren
  '/organizations/$organizationId': typeof AuthOrganizationsOrganizationIdRouteWithChildren
  '/patients/$patientId': typeof AuthPatientsPatientIdRouteWithChildren
  '/practitioners/$practitionerId': typeof AuthPractitionersPractitionerIdRouteWithChildren
  '/practitioners/new': typeof AuthPractitionersNewRoute
  '/appointments/': typeof AuthAppointmentsIndexRoute
  '/faxes/': typeof AuthFaxesIndexRoute
  '/home/': typeof AuthHomeIndexRoute
  '/inbox/': typeof AuthInboxIndexRoute
  '/organizations/': typeof AuthOrganizationsIndexRoute
  '/patients/': typeof AuthPatientsIndexRoute
  '/practitioners/': typeof AuthPractitionersIndexRoute
  '/schedule-availability/': typeof AuthScheduleAvailabilityIndexRoute
  '/support/': typeof AuthSupportIndexRoute
  '/worklist/': typeof AuthWorklistIndexRoute
  '/care-plan/$patientId/data': typeof AuthCarePlanPatientIdDataRoute
  '/care-plan/$patientId/day': typeof AuthCarePlanPatientIdDayRoute
  '/care-plan/$patientId/erx2': typeof AuthCarePlanPatientIdErx2Route
  '/care-plan/$patientId/plan': typeof AuthCarePlanPatientIdPlanRoute
  '/internal/agent-trace/health': typeof AuthInternalAgentTraceHealthRoute
  '/internal/protocols/$canonical': typeof AuthInternalProtocolsCanonicalRoute
  '/organizations/$organizationId/external-providers': typeof AuthOrganizationsOrganizationIdExternalProvidersRoute
  '/care-plan/$patientId/': typeof AuthCarePlanPatientIdIndexRoute
  '/internal/agent-trace/': typeof AuthInternalAgentTraceIndexRoute
  '/internal/protocols/': typeof AuthInternalProtocolsIndexRoute
  '/organizations/$organizationId/': typeof AuthOrganizationsOrganizationIdIndexRoute
  '/patients/$patientId/': typeof AuthPatientsPatientIdIndexRoute
  '/practitioners/$practitionerId/': typeof AuthPractitionersPractitionerIdIndexRoute
  '/provider/$patientId/': typeof AuthProviderPatientIdIndexRoute
  '/internal/agent-trace/$triggerType/$triggerId': typeof AuthInternalAgentTraceTriggerTypeTriggerIdRoute
  '/practitioners/$practitionerId/project-membership/$membershipId': typeof AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute
}
export interface FileRoutesByTo {
  '/prep_guides': typeof AuthPrep_guidesRoute
  '/login/callback': typeof LoginCallbackRoute
  '/': typeof AuthIndexRoute
  '/practitioners/new': typeof AuthPractitionersNewRoute
  '/appointments': typeof AuthAppointmentsIndexRoute
  '/faxes': typeof AuthFaxesIndexRoute
  '/home': typeof AuthHomeIndexRoute
  '/inbox': typeof AuthInboxIndexRoute
  '/organizations': typeof AuthOrganizationsIndexRoute
  '/patients': typeof AuthPatientsIndexRoute
  '/practitioners': typeof AuthPractitionersIndexRoute
  '/schedule-availability': typeof AuthScheduleAvailabilityIndexRoute
  '/support': typeof AuthSupportIndexRoute
  '/worklist': typeof AuthWorklistIndexRoute
  '/care-plan/$patientId/data': typeof AuthCarePlanPatientIdDataRoute
  '/care-plan/$patientId/day': typeof AuthCarePlanPatientIdDayRoute
  '/care-plan/$patientId/erx2': typeof AuthCarePlanPatientIdErx2Route
  '/care-plan/$patientId/plan': typeof AuthCarePlanPatientIdPlanRoute
  '/internal/agent-trace/health': typeof AuthInternalAgentTraceHealthRoute
  '/internal/protocols/$canonical': typeof AuthInternalProtocolsCanonicalRoute
  '/organizations/$organizationId/external-providers': typeof AuthOrganizationsOrganizationIdExternalProvidersRoute
  '/care-plan/$patientId': typeof AuthCarePlanPatientIdIndexRoute
  '/internal/agent-trace': typeof AuthInternalAgentTraceIndexRoute
  '/internal/protocols': typeof AuthInternalProtocolsIndexRoute
  '/organizations/$organizationId': typeof AuthOrganizationsOrganizationIdIndexRoute
  '/patients/$patientId': typeof AuthPatientsPatientIdIndexRoute
  '/practitioners/$practitionerId': typeof AuthPractitionersPractitionerIdIndexRoute
  '/provider/$patientId': typeof AuthProviderPatientIdIndexRoute
  '/internal/agent-trace/$triggerType/$triggerId': typeof AuthInternalAgentTraceTriggerTypeTriggerIdRoute
  '/practitioners/$practitionerId/project-membership/$membershipId': typeof AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/prep_guides': typeof AuthPrep_guidesRoute
  '/login/callback': typeof LoginCallbackRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/care-plan/$patientId': typeof AuthCarePlanPatientIdRouteWithChildren
  '/_auth/organizations/$organizationId': typeof AuthOrganizationsOrganizationIdRouteWithChildren
  '/_auth/patients/$patientId': typeof AuthPatientsPatientIdRouteWithChildren
  '/_auth/practitioners/$practitionerId': typeof AuthPractitionersPractitionerIdRouteWithChildren
  '/_auth/practitioners/new': typeof AuthPractitionersNewRoute
  '/_auth/appointments/': typeof AuthAppointmentsIndexRoute
  '/_auth/faxes/': typeof AuthFaxesIndexRoute
  '/_auth/home/': typeof AuthHomeIndexRoute
  '/_auth/inbox/': typeof AuthInboxIndexRoute
  '/_auth/organizations/': typeof AuthOrganizationsIndexRoute
  '/_auth/patients/': typeof AuthPatientsIndexRoute
  '/_auth/practitioners/': typeof AuthPractitionersIndexRoute
  '/_auth/schedule-availability/': typeof AuthScheduleAvailabilityIndexRoute
  '/_auth/support/': typeof AuthSupportIndexRoute
  '/_auth/worklist/': typeof AuthWorklistIndexRoute
  '/_auth/care-plan/$patientId/data': typeof AuthCarePlanPatientIdDataRoute
  '/_auth/care-plan/$patientId/day': typeof AuthCarePlanPatientIdDayRoute
  '/_auth/care-plan/$patientId/erx2': typeof AuthCarePlanPatientIdErx2Route
  '/_auth/care-plan/$patientId/plan': typeof AuthCarePlanPatientIdPlanRoute
  '/_auth/internal/agent-trace/health': typeof AuthInternalAgentTraceHealthRoute
  '/_auth/internal/protocols/$canonical': typeof AuthInternalProtocolsCanonicalRoute
  '/_auth/organizations/$organizationId/external-providers': typeof AuthOrganizationsOrganizationIdExternalProvidersRoute
  '/_auth/care-plan/$patientId/': typeof AuthCarePlanPatientIdIndexRoute
  '/_auth/internal/agent-trace/': typeof AuthInternalAgentTraceIndexRoute
  '/_auth/internal/protocols/': typeof AuthInternalProtocolsIndexRoute
  '/_auth/organizations/$organizationId/': typeof AuthOrganizationsOrganizationIdIndexRoute
  '/_auth/patients/$patientId/': typeof AuthPatientsPatientIdIndexRoute
  '/_auth/practitioners/$practitionerId/': typeof AuthPractitionersPractitionerIdIndexRoute
  '/_auth/provider/$patientId/': typeof AuthProviderPatientIdIndexRoute
  '/_auth/internal/agent-trace/$triggerType/$triggerId': typeof AuthInternalAgentTraceTriggerTypeTriggerIdRoute
  '/_auth/practitioners/$practitionerId/project-membership/$membershipId': typeof AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/prep_guides'
    | '/login/callback'
    | '/care-plan/$patientId'
    | '/organizations/$organizationId'
    | '/patients/$patientId'
    | '/practitioners/$practitionerId'
    | '/practitioners/new'
    | '/appointments/'
    | '/faxes/'
    | '/home/'
    | '/inbox/'
    | '/organizations/'
    | '/patients/'
    | '/practitioners/'
    | '/schedule-availability/'
    | '/support/'
    | '/worklist/'
    | '/care-plan/$patientId/data'
    | '/care-plan/$patientId/day'
    | '/care-plan/$patientId/erx2'
    | '/care-plan/$patientId/plan'
    | '/internal/agent-trace/health'
    | '/internal/protocols/$canonical'
    | '/organizations/$organizationId/external-providers'
    | '/care-plan/$patientId/'
    | '/internal/agent-trace/'
    | '/internal/protocols/'
    | '/organizations/$organizationId/'
    | '/patients/$patientId/'
    | '/practitioners/$practitionerId/'
    | '/provider/$patientId/'
    | '/internal/agent-trace/$triggerType/$triggerId'
    | '/practitioners/$practitionerId/project-membership/$membershipId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/prep_guides'
    | '/login/callback'
    | '/'
    | '/practitioners/new'
    | '/appointments'
    | '/faxes'
    | '/home'
    | '/inbox'
    | '/organizations'
    | '/patients'
    | '/practitioners'
    | '/schedule-availability'
    | '/support'
    | '/worklist'
    | '/care-plan/$patientId/data'
    | '/care-plan/$patientId/day'
    | '/care-plan/$patientId/erx2'
    | '/care-plan/$patientId/plan'
    | '/internal/agent-trace/health'
    | '/internal/protocols/$canonical'
    | '/organizations/$organizationId/external-providers'
    | '/care-plan/$patientId'
    | '/internal/agent-trace'
    | '/internal/protocols'
    | '/organizations/$organizationId'
    | '/patients/$patientId'
    | '/practitioners/$practitionerId'
    | '/provider/$patientId'
    | '/internal/agent-trace/$triggerType/$triggerId'
    | '/practitioners/$practitionerId/project-membership/$membershipId'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/prep_guides'
    | '/login/callback'
    | '/_auth/'
    | '/_auth/care-plan/$patientId'
    | '/_auth/organizations/$organizationId'
    | '/_auth/patients/$patientId'
    | '/_auth/practitioners/$practitionerId'
    | '/_auth/practitioners/new'
    | '/_auth/appointments/'
    | '/_auth/faxes/'
    | '/_auth/home/'
    | '/_auth/inbox/'
    | '/_auth/organizations/'
    | '/_auth/patients/'
    | '/_auth/practitioners/'
    | '/_auth/schedule-availability/'
    | '/_auth/support/'
    | '/_auth/worklist/'
    | '/_auth/care-plan/$patientId/data'
    | '/_auth/care-plan/$patientId/day'
    | '/_auth/care-plan/$patientId/erx2'
    | '/_auth/care-plan/$patientId/plan'
    | '/_auth/internal/agent-trace/health'
    | '/_auth/internal/protocols/$canonical'
    | '/_auth/organizations/$organizationId/external-providers'
    | '/_auth/care-plan/$patientId/'
    | '/_auth/internal/agent-trace/'
    | '/_auth/internal/protocols/'
    | '/_auth/organizations/$organizationId/'
    | '/_auth/patients/$patientId/'
    | '/_auth/practitioners/$practitionerId/'
    | '/_auth/provider/$patientId/'
    | '/_auth/internal/agent-trace/$triggerType/$triggerId'
    | '/_auth/practitioners/$practitionerId/project-membership/$membershipId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginCallbackRoute: typeof LoginCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prep_guides': {
      id: '/_auth/prep_guides'
      path: '/prep_guides'
      fullPath: '/prep_guides'
      preLoaderRoute: typeof AuthPrep_guidesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/appointments/': {
      id: '/_auth/appointments/'
      path: '/appointments'
      fullPath: '/appointments/'
      preLoaderRoute: typeof AuthAppointmentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/care-plan/$patientId': {
      id: '/_auth/care-plan/$patientId'
      path: '/care-plan/$patientId'
      fullPath: '/care-plan/$patientId'
      preLoaderRoute: typeof AuthCarePlanPatientIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/faxes/': {
      id: '/_auth/faxes/'
      path: '/faxes'
      fullPath: '/faxes/'
      preLoaderRoute: typeof AuthFaxesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home/': {
      id: '/_auth/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthHomeIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox/': {
      id: '/_auth/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AuthInboxIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/': {
      id: '/_auth/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthOrganizationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/$organizationId': {
      id: '/_auth/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/patients/': {
      id: '/_auth/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthPatientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/patients/$patientId': {
      id: '/_auth/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthPatientsPatientIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/practitioners/': {
      id: '/_auth/practitioners/'
      path: '/practitioners'
      fullPath: '/practitioners/'
      preLoaderRoute: typeof AuthPractitionersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/practitioners/$practitionerId': {
      id: '/_auth/practitioners/$practitionerId'
      path: '/practitioners/$practitionerId'
      fullPath: '/practitioners/$practitionerId'
      preLoaderRoute: typeof AuthPractitionersPractitionerIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/practitioners/new': {
      id: '/_auth/practitioners/new'
      path: '/practitioners/new'
      fullPath: '/practitioners/new'
      preLoaderRoute: typeof AuthPractitionersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schedule-availability/': {
      id: '/_auth/schedule-availability/'
      path: '/schedule-availability'
      fullPath: '/schedule-availability/'
      preLoaderRoute: typeof AuthScheduleAvailabilityIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/support/': {
      id: '/_auth/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthSupportIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/worklist/': {
      id: '/_auth/worklist/'
      path: '/worklist'
      fullPath: '/worklist/'
      preLoaderRoute: typeof AuthWorklistIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/care-plan/$patientId/': {
      id: '/_auth/care-plan/$patientId/'
      path: '/'
      fullPath: '/care-plan/$patientId/'
      preLoaderRoute: typeof AuthCarePlanPatientIdIndexRouteImport
      parentRoute: typeof AuthCarePlanPatientIdRoute
    }
    '/_auth/care-plan/$patientId/data': {
      id: '/_auth/care-plan/$patientId/data'
      path: '/data'
      fullPath: '/care-plan/$patientId/data'
      preLoaderRoute: typeof AuthCarePlanPatientIdDataRouteImport
      parentRoute: typeof AuthCarePlanPatientIdRoute
    }
    '/_auth/care-plan/$patientId/day': {
      id: '/_auth/care-plan/$patientId/day'
      path: '/day'
      fullPath: '/care-plan/$patientId/day'
      preLoaderRoute: typeof AuthCarePlanPatientIdDayRouteImport
      parentRoute: typeof AuthCarePlanPatientIdRoute
    }
    '/_auth/care-plan/$patientId/erx2': {
      id: '/_auth/care-plan/$patientId/erx2'
      path: '/erx2'
      fullPath: '/care-plan/$patientId/erx2'
      preLoaderRoute: typeof AuthCarePlanPatientIdErx2RouteImport
      parentRoute: typeof AuthCarePlanPatientIdRoute
    }
    '/_auth/care-plan/$patientId/plan': {
      id: '/_auth/care-plan/$patientId/plan'
      path: '/plan'
      fullPath: '/care-plan/$patientId/plan'
      preLoaderRoute: typeof AuthCarePlanPatientIdPlanRouteImport
      parentRoute: typeof AuthCarePlanPatientIdRoute
    }
    '/_auth/internal/agent-trace/': {
      id: '/_auth/internal/agent-trace/'
      path: '/internal/agent-trace'
      fullPath: '/internal/agent-trace/'
      preLoaderRoute: typeof AuthInternalAgentTraceIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal/agent-trace/health': {
      id: '/_auth/internal/agent-trace/health'
      path: '/internal/agent-trace/health'
      fullPath: '/internal/agent-trace/health'
      preLoaderRoute: typeof AuthInternalAgentTraceHealthRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal/protocols/': {
      id: '/_auth/internal/protocols/'
      path: '/internal/protocols'
      fullPath: '/internal/protocols/'
      preLoaderRoute: typeof AuthInternalProtocolsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal/protocols/$canonical': {
      id: '/_auth/internal/protocols/$canonical'
      path: '/internal/protocols/$canonical'
      fullPath: '/internal/protocols/$canonical'
      preLoaderRoute: typeof AuthInternalProtocolsCanonicalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/$organizationId/': {
      id: '/_auth/organizations/$organizationId/'
      path: '/'
      fullPath: '/organizations/$organizationId/'
      preLoaderRoute: typeof AuthOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthOrganizationsOrganizationIdRoute
    }
    '/_auth/organizations/$organizationId/external-providers': {
      id: '/_auth/organizations/$organizationId/external-providers'
      path: '/external-providers'
      fullPath: '/organizations/$organizationId/external-providers'
      preLoaderRoute: typeof AuthOrganizationsOrganizationIdExternalProvidersRouteImport
      parentRoute: typeof AuthOrganizationsOrganizationIdRoute
    }
    '/_auth/patients/$patientId/': {
      id: '/_auth/patients/$patientId/'
      path: '/'
      fullPath: '/patients/$patientId/'
      preLoaderRoute: typeof AuthPatientsPatientIdIndexRouteImport
      parentRoute: typeof AuthPatientsPatientIdRoute
    }
    '/_auth/practitioners/$practitionerId/': {
      id: '/_auth/practitioners/$practitionerId/'
      path: '/'
      fullPath: '/practitioners/$practitionerId/'
      preLoaderRoute: typeof AuthPractitionersPractitionerIdIndexRouteImport
      parentRoute: typeof AuthPractitionersPractitionerIdRoute
    }
    '/_auth/provider/$patientId/': {
      id: '/_auth/provider/$patientId/'
      path: '/provider/$patientId'
      fullPath: '/provider/$patientId/'
      preLoaderRoute: typeof AuthProviderPatientIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal/agent-trace/$triggerType/$triggerId': {
      id: '/_auth/internal/agent-trace/$triggerType/$triggerId'
      path: '/internal/agent-trace/$triggerType/$triggerId'
      fullPath: '/internal/agent-trace/$triggerType/$triggerId'
      preLoaderRoute: typeof AuthInternalAgentTraceTriggerTypeTriggerIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/practitioners/$practitionerId/project-membership/$membershipId': {
      id: '/_auth/practitioners/$practitionerId/project-membership/$membershipId'
      path: '/project-membership/$membershipId'
      fullPath: '/practitioners/$practitionerId/project-membership/$membershipId'
      preLoaderRoute: typeof AuthPractitionersPractitionerIdProjectMembershipMembershipIdRouteImport
      parentRoute: typeof AuthPractitionersPractitionerIdRoute
    }
  }
}

interface AuthCarePlanPatientIdRouteChildren {
  AuthCarePlanPatientIdDataRoute: typeof AuthCarePlanPatientIdDataRoute
  AuthCarePlanPatientIdDayRoute: typeof AuthCarePlanPatientIdDayRoute
  AuthCarePlanPatientIdErx2Route: typeof AuthCarePlanPatientIdErx2Route
  AuthCarePlanPatientIdPlanRoute: typeof AuthCarePlanPatientIdPlanRoute
  AuthCarePlanPatientIdIndexRoute: typeof AuthCarePlanPatientIdIndexRoute
}

const AuthCarePlanPatientIdRouteChildren: AuthCarePlanPatientIdRouteChildren = {
  AuthCarePlanPatientIdDataRoute: AuthCarePlanPatientIdDataRoute,
  AuthCarePlanPatientIdDayRoute: AuthCarePlanPatientIdDayRoute,
  AuthCarePlanPatientIdErx2Route: AuthCarePlanPatientIdErx2Route,
  AuthCarePlanPatientIdPlanRoute: AuthCarePlanPatientIdPlanRoute,
  AuthCarePlanPatientIdIndexRoute: AuthCarePlanPatientIdIndexRoute,
}

const AuthCarePlanPatientIdRouteWithChildren =
  AuthCarePlanPatientIdRoute._addFileChildren(
    AuthCarePlanPatientIdRouteChildren,
  )

interface AuthOrganizationsOrganizationIdRouteChildren {
  AuthOrganizationsOrganizationIdExternalProvidersRoute: typeof AuthOrganizationsOrganizationIdExternalProvidersRoute
  AuthOrganizationsOrganizationIdIndexRoute: typeof AuthOrganizationsOrganizationIdIndexRoute
}

const AuthOrganizationsOrganizationIdRouteChildren: AuthOrganizationsOrganizationIdRouteChildren =
  {
    AuthOrganizationsOrganizationIdExternalProvidersRoute:
      AuthOrganizationsOrganizationIdExternalProvidersRoute,
    AuthOrganizationsOrganizationIdIndexRoute:
      AuthOrganizationsOrganizationIdIndexRoute,
  }

const AuthOrganizationsOrganizationIdRouteWithChildren =
  AuthOrganizationsOrganizationIdRoute._addFileChildren(
    AuthOrganizationsOrganizationIdRouteChildren,
  )

interface AuthPatientsPatientIdRouteChildren {
  AuthPatientsPatientIdIndexRoute: typeof AuthPatientsPatientIdIndexRoute
}

const AuthPatientsPatientIdRouteChildren: AuthPatientsPatientIdRouteChildren = {
  AuthPatientsPatientIdIndexRoute: AuthPatientsPatientIdIndexRoute,
}

const AuthPatientsPatientIdRouteWithChildren =
  AuthPatientsPatientIdRoute._addFileChildren(
    AuthPatientsPatientIdRouteChildren,
  )

interface AuthPractitionersPractitionerIdRouteChildren {
  AuthPractitionersPractitionerIdIndexRoute: typeof AuthPractitionersPractitionerIdIndexRoute
  AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute: typeof AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute
}

const AuthPractitionersPractitionerIdRouteChildren: AuthPractitionersPractitionerIdRouteChildren =
  {
    AuthPractitionersPractitionerIdIndexRoute:
      AuthPractitionersPractitionerIdIndexRoute,
    AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute:
      AuthPractitionersPractitionerIdProjectMembershipMembershipIdRoute,
  }

const AuthPractitionersPractitionerIdRouteWithChildren =
  AuthPractitionersPractitionerIdRoute._addFileChildren(
    AuthPractitionersPractitionerIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthPrep_guidesRoute: typeof AuthPrep_guidesRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthCarePlanPatientIdRoute: typeof AuthCarePlanPatientIdRouteWithChildren
  AuthOrganizationsOrganizationIdRoute: typeof AuthOrganizationsOrganizationIdRouteWithChildren
  AuthPatientsPatientIdRoute: typeof AuthPatientsPatientIdRouteWithChildren
  AuthPractitionersPractitionerIdRoute: typeof AuthPractitionersPractitionerIdRouteWithChildren
  AuthPractitionersNewRoute: typeof AuthPractitionersNewRoute
  AuthAppointmentsIndexRoute: typeof AuthAppointmentsIndexRoute
  AuthFaxesIndexRoute: typeof AuthFaxesIndexRoute
  AuthHomeIndexRoute: typeof AuthHomeIndexRoute
  AuthInboxIndexRoute: typeof AuthInboxIndexRoute
  AuthOrganizationsIndexRoute: typeof AuthOrganizationsIndexRoute
  AuthPatientsIndexRoute: typeof AuthPatientsIndexRoute
  AuthPractitionersIndexRoute: typeof AuthPractitionersIndexRoute
  AuthScheduleAvailabilityIndexRoute: typeof AuthScheduleAvailabilityIndexRoute
  AuthSupportIndexRoute: typeof AuthSupportIndexRoute
  AuthWorklistIndexRoute: typeof AuthWorklistIndexRoute
  AuthInternalAgentTraceHealthRoute: typeof AuthInternalAgentTraceHealthRoute
  AuthInternalProtocolsCanonicalRoute: typeof AuthInternalProtocolsCanonicalRoute
  AuthInternalAgentTraceIndexRoute: typeof AuthInternalAgentTraceIndexRoute
  AuthInternalProtocolsIndexRoute: typeof AuthInternalProtocolsIndexRoute
  AuthProviderPatientIdIndexRoute: typeof AuthProviderPatientIdIndexRoute
  AuthInternalAgentTraceTriggerTypeTriggerIdRoute: typeof AuthInternalAgentTraceTriggerTypeTriggerIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthPrep_guidesRoute: AuthPrep_guidesRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthCarePlanPatientIdRoute: AuthCarePlanPatientIdRouteWithChildren,
  AuthOrganizationsOrganizationIdRoute:
    AuthOrganizationsOrganizationIdRouteWithChildren,
  AuthPatientsPatientIdRoute: AuthPatientsPatientIdRouteWithChildren,
  AuthPractitionersPractitionerIdRoute:
    AuthPractitionersPractitionerIdRouteWithChildren,
  AuthPractitionersNewRoute: AuthPractitionersNewRoute,
  AuthAppointmentsIndexRoute: AuthAppointmentsIndexRoute,
  AuthFaxesIndexRoute: AuthFaxesIndexRoute,
  AuthHomeIndexRoute: AuthHomeIndexRoute,
  AuthInboxIndexRoute: AuthInboxIndexRoute,
  AuthOrganizationsIndexRoute: AuthOrganizationsIndexRoute,
  AuthPatientsIndexRoute: AuthPatientsIndexRoute,
  AuthPractitionersIndexRoute: AuthPractitionersIndexRoute,
  AuthScheduleAvailabilityIndexRoute: AuthScheduleAvailabilityIndexRoute,
  AuthSupportIndexRoute: AuthSupportIndexRoute,
  AuthWorklistIndexRoute: AuthWorklistIndexRoute,
  AuthInternalAgentTraceHealthRoute: AuthInternalAgentTraceHealthRoute,
  AuthInternalProtocolsCanonicalRoute: AuthInternalProtocolsCanonicalRoute,
  AuthInternalAgentTraceIndexRoute: AuthInternalAgentTraceIndexRoute,
  AuthInternalProtocolsIndexRoute: AuthInternalProtocolsIndexRoute,
  AuthProviderPatientIdIndexRoute: AuthProviderPatientIdIndexRoute,
  AuthInternalAgentTraceTriggerTypeTriggerIdRoute:
    AuthInternalAgentTraceTriggerTypeTriggerIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginCallbackRoute: LoginCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
